import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Button, Spinner } from '@telus-uds/components-web';

import request from '../../../../../../../../../utils/request';
import { EditOverlay } from '../../../../css';

const Overlay = ({ name, fetchData, setInDisableMode, isDeleted }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const resetState = () => {
    setIsDeleting(false);
    setInDisableMode(false);
    fetchData();
  };

  const handleDisable = async () => {
    setIsDeleting(true);
    try {
      const result = await request.put(`/disableOutletId`, {
        outletId: name,
        status: isDeleted ? 0 : 1
      });
      if (result && result.status === 200) {
        setInDisableMode(false);
        fetchData();
      }
    } catch (err) {
      resetState();
      throw err;
    }
  };

  return (
    <EditOverlay>
      <Spinner
        label={`${isDeleted ? 'enabling...' : 'disabling...'}`}
        show={isDeleting}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            width: '100%'
          }}
        >
          <p style={{ fontWeight: '600', textAlign: 'center' }}>
            Are you sure you want to {isDeleted ? 'enable' : 'disable'} {name}?
          </p>
          <Button type="button" onPress={handleDisable}>
            Confirm
          </Button>
          <Button
            variant={{ priority: 'low' }}
            type="button"
            onPress={() => setInDisableMode(false)}
          >
            Cancel
          </Button>
        </div>
      </Spinner>
    </EditOverlay>
  );
};

Overlay.propTypes = {
  name: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired,
  setInDisableMode: PropTypes.func.isRequired,
  isDeleted: PropTypes.bool.isRequired
};

export default Overlay;
